import ClassicSkin from './classic';
import NeoSkin from './neo';

const SKINS = {
  DEFAULT: {
    code: 'DEFAULT',
    label: 'Classic',
    component: ClassicSkin,
  },
  NEO: {
    code: 'NEO',
    label: 'Neo',
    component: NeoSkin,
  },
};

export const getSkin = (code) => SKINS[code] ?? SKINS.DEFAULT;

export default SKINS;
